<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!caricamentoInCorso"
  [dismissableMask]="!caricamentoInCorso"
  [style]="{width: '600px'}"
  styleClass="p-fluid carica-lettera-dialog"
  [showHeader]="false"
  (onHide)="onHide()">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-file-pdf header-icon"></i>
        <h2>Carica lettera per il {{ richiesta?.enteEsecutore?.label || '' }}</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        [disabled]="caricamentoInCorso"
        (click)="onHide()">
      </button>
    </div>

    <div class="dialog-content">
      <p class="mb-3">Seleziona il file PDF della lettera inviata all'ente</p>

      <div class="card-upload">
        <div *ngIf="!fileSelezionato">
          <p-fileUpload
            #fileUpload
            mode="basic"
            chooseLabel="Seleziona PDF"
            accept="application/pdf"
            [maxFileSize]="maxFileSize"
            [auto]="false"
            [disabled]="caricamentoInCorso"
            [style]="{'width':'100%'}"
            styleClass="p-button-outlined p-button-primary upload-button"
            (onSelect)="onSelect($event)"
            (onClear)="onClear()">
          </p-fileUpload>
        </div>

        <div *ngIf="fileSelezionato" class="file-info mt-3">
          <i class="pi pi-file-pdf" style="font-size: 1.5rem; color: #ff5252;"></i>
          <div class="file-details">
            <span class="file-name">{{ fileSelezionato.name }}</span>
            <span class="file-size">{{ (fileSelezionato.size / 1024 / 1024).toFixed(2) }} MB</span>
          </div>

          <button
            *ngIf="!caricamentoInCorso"
            pButton
            type="button"
            icon="pi pi-times"
            class="p-button-rounded p-button-text p-button-danger ml-auto"
            (click)="onClear()"
            pTooltip="Rimuovi file">
          </button>
        </div>

        <div *ngIf="caricamentoInCorso" class="mt-4">
          <p-progressBar [value]="progressoCaricamento" [showValue]="true" [style]="{'height': '20px'}"></p-progressBar>
        </div>
      </div>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        [disabled]="caricamentoInCorso"
        (click)="onHide()">
      </button>
      <button
        pButton
        pRipple
        label="Carica"
        icon="pi pi-upload"
        class="p-button-primary"
        [loading]="caricamentoInCorso"
        [disabled]="!fileSelezionato || caricamentoInCorso"
        (click)="confermaCaricamento()">
      </button>
    </div>
  </div>
</p-dialog>
